<template>
  <button
    type="button"
    :class="['submit', 'submit--' + variant, noIcon === true ? 'submit--noIcon' : '', currentStatus !== 'default' ? 'submit--' + currentStatus : '', disabled === true ? 'submit--disabled' : '']"
    :disabled="disabled === true || currentStatus === 'loading' || currentStatus === 'success' ? true : false"
    @click="createRipple($event); $emit('click')"
  >
    <transition
      v-if="noIcon === false"
      name="submit__transition--icon"
    >
      <span
        class="submit__icon"
        :key="'icon--' + currentStatus"
        v-html="currentIcon"
      />
    </transition>

    <transition
      name="submit__transition--text"
      mode="out-in"
    >
      <span
        class="submit__text"
        :key="'text--' + currentStatus"
      >
        <slot />
      </span>
    </transition>
  </button>
</template>

<script>
import helperMethods from '@/helpers/utility.js'

export default {
  props: {
    status: {
      type: String,
      default: 'default',
      validator (values) {
        return ['default', 'loading', 'error', 'success'].includes(values)
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M13 18v-4h-7v-4h7v-4l6 6-6 6zm-1-16c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z"/></svg>'
    },
    noIcon: {
      type: Boolean,
      default: false
    },
    variant: {
      type: [String],
      default: 'blue',
      validator (values) {
        return ['blue', 'delete'].includes(values)
      }
    }
  },
  computed: {
    currentStatus () {
      return this.status
    },
    currentIcon () {
      if (this.currentStatus === 'success') {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M21.856 10.303c.086.554.144 1.118.144 1.697 0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11c2.347 0 4.518.741 6.304 1.993l-1.422 1.457c-1.408-.913-3.082-1.45-4.882-1.45-4.962 0-9 4.038-9 9s4.038 9 9 9c4.894 0 8.879-3.928 8.99-8.795l1.866-1.902zm-.952-8.136l-9.404 9.639-3.843-3.614-3.095 3.098 6.938 6.71 12.5-12.737-3.096-3.096z"/></svg>'
      } else if(this.currentStatus === 'loading') {
        return '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" width="100%" height="100%" viewBox="0 0 24 24" enable-background="new 0 0 0 0"xml:space="preserve"><path d="M13.75 22c0 .966-.783 1.75-1.75 1.75s-1.75-.784-1.75-1.75.783-1.75 1.75-1.75 1.75.784 1.75 1.75zm-1.75-22c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm10 10.75c.689 0 1.249.561 1.249 1.25 0 .69-.56 1.25-1.249 1.25-.69 0-1.249-.559-1.249-1.25 0-.689.559-1.25 1.249-1.25zm-22 1.25c0 1.105.896 2 2 2s2-.895 2-2c0-1.104-.896-2-2-2s-2 .896-2 2zm19-8c.551 0 1 .449 1 1 0 .553-.449 1.002-1 1-.551 0-1-.447-1-.998 0-.553.449-1.002 1-1.002zm0 13.5c.828 0 1.5.672 1.5 1.5s-.672 1.501-1.502 1.5c-.826 0-1.498-.671-1.498-1.499 0-.829.672-1.501 1.5-1.501zm-14-14.5c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm0 14c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2z"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="2s" from="360 12 12" to="0 12 12" repeatCount="indefinite" /></path></svg>'
      }
      return this.icon
    }
  },
  methods: {
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.submit {
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 0.4rem 2rem 0.4rem 4rem;
  //margin: 0 auto;
  display: inline-block;
  outline: none;
  user-select: none;
  position: relative;
  transition: all 0.3s;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    transition: all 0.3s;
    width: 3.5rem;
    height: 200%;
    background-color: $blue;
    z-index: 1;
    left: -1rem;
    top: 0;
    transform-origin: 0 0;
    transform: rotate(-20deg);
  }

  &:hover {
    background-color: darken($blue, 8);

    &:after {
      width: 2.125rem;
      left: 0rem;
      background-color: $blue;
    }
  }

  &:active {
    background: darken($blue, 15);

    &:after {
      transition: all 0.1s;
      width: 0rem;
      left: 1.0625rem;
      background-color: $blue;
    }
  }

  &--noIcon {
    padding: 0.4rem 2rem;
  }

  &--blue {
    border: 1px solid $blue;
    background-color: darken($blue, 4);

    &:after {
      background-color: $blue;
    }

    &:hover {
      background-color: darken($blue, 8);

      &:after {
        background-color: $blue;
      }
    }

    &:active {
      background: darken($blue, 15);

      &:after {
        background-color: $blue;
      }
    }

    .submit__icon {
      fill: rgba($white, 0.9);
    }

    .submit__text {
      color: rgba($white, 0.9);
    }
  }

  &--delete {
    border: 1px solid darken(rgba($red, 0.2), 8);
    background-color: rgba($black, 0);

    &:after {
      background-color: rgba($black, 0);
    }

    &:hover {
      background-color: darken(rgba($red, 0.2), 8);

      &:after {
        background-color: darken(rgba($red, 0.2), 8);
      }
    }

    &:active {
      background: darken($red, 35);

      &:after {
        background-color: $red;
      }
    }

    .submit__icon {
      fill: rgba($white, 0.9);
    }

    .submit__text {
      color: rgba($white, 0.9);
    }
  }

  &--disabled {
    border: 1px solid $bg-1;
    background-color: darken($bg-3, 4);

    &:after {
      background-color: $bg-3;
    }

    &:hover {
      background-color: darken($bg-3, 8);

      &:after {
        background-color: $bg-3;
      }
    }

    &:active {
      background: darken($bg-3, 15);

      &:after {
        background-color: $bg-3;
      }
    }

    .submit__icon {
      fill: rgba($white, 0.5);
    }

    .submit__text {
      color: rgba($white, 0.5);
    }
  }

  &--large {
    width: 420px;
    height: 52px;
    margin: 0.5rem auto;
  }

  &__transition {
    &--icon {
      &-enter-active, &-leave-active {
        transition: opacity 0.5s cubic-bezier(0.0, 0.0, 0.3, 1.0), transform 0.5s cubic-bezier(0.0, 0.0, 0.3, 1.0);
      }
      &-enter, &-leave-to {
        opacity: 0;
        transform: scale(0);
      }
    }

    &--text {
      &-enter-active, &-leave-active {
        transition: opacity 0.4s cubic-bezier(0.0, 0.0, 0.3, 1.0);
      }
      &-enter, &-leave-to {
        opacity: 0;
      }
    }
  }

  &__text {
    @include font('content--md');
    text-transform: uppercase;
    letter-spacing: 0.025rem;
    text-transform: uppercase;
    position: relative;
    white-space: normal;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--lg');
      text-transform: uppercase;
      letter-spacing: 0.025rem;
      text-transform: uppercase;
      position: relative;
      white-space: normal;
    }
  }

  &__icon {
    position: absolute;
    z-index: 10;
    display: inline-block;
    width: 1.25rem;
    height: 1.25rem;
    top: calc(50% - 0.625rem);
    left: 1rem;
    fill: $white;

    @media screen and (min-width: $breakpointLg) {
      width: 1.35rem;
      height: 1.35rem;
      top: calc(50% - 0.675rem);
      left: 0.9rem;
    }
  }
}

</style>
